var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('vs-wrapper',[_c('vs-heading',[_vm._v("Access")]),_c('vs-autocomplete',{attrs:{"items":_setup.hubs,"value":_setup.props.accessBusinessUnitIds,"label":"Hub","multiselect":"","rules":[
      (items) =>
        _setup.props.accessGrantRequired &&
        items?.length === 0 &&
        'One or more hubs are required',
    ]},on:{"input":function($event){return _setup.handleAccessUpdate({ field: 'accessBusinessUnitIds', value: $event })}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }